// @vue/component
import LayoutDefault from '@/layouts/LayoutClient.vue'
import { mapActions, mapGetters } from 'vuex'
import QList from '@/components/common/exhibitions/c-list.vue'
import TasksList from '@/components/common/tasks/c-list.vue'
import QListItem from '@/components/common/exhibitions/c-list-item.vue'
import IdPopup from './id-popup.vue'
import dateTimeMixin from '@/mixins/datetime'
import colorsMixin from '@/mixins/colors'
import cssMixin from '@/mixins/css'
import DoctorProfile from '@/components/doctor/profile.vue'
import { Timer } from 'easytimer.js';
import vueFilePond from "vue-filepond";
import apiConfig from '@/static/apiConfig'

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageCrop from "filepond-plugin-image-crop";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import TokenService from '@/services/token.service'
import FilePondPluginImageEdit from "filepond-plugin-image-edit";
import "filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css";
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageFilter from 'filepond-plugin-image-filter';


import CropperEditor from 'cropperjs';

// Create component
const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginImageCrop,
    FilePondPluginImageResize,
    FilePondPluginImageTransform,
    FilePondPluginImageEdit,
    FilePondPluginImageExifOrientation,
    FilePondPluginImageFilter
);


export default {
    name: 'Exhibitions',

    components: {
        LayoutDefault,
        IdPopup,
        FilePond,
        DoctorProfile,
        TasksList,
        QList,
        QListItem
    },

    mixins: [dateTimeMixin, colorsMixin, cssMixin],

    props: {},

    data () {
        return {
            rooms: [],
            myFiles: [],
            files: [],
            filter: localStorage.getItem('filterExhibitions') || 'official',
            filterOptions: [
                {name: 'Наши', value: 'official'},
                {name: 'Ваши', value: 'personal'},
                //{name: 'Общие', value: 'common'},
            ],
            exhibition: {},
            currentDay: 1,
            sessionClock: '',
            filterFlow: 'noPinned',
            filterSection: 'exhibitions',
            filterTabs: 0,
            errorMessage: '',
            dialogViewExhibition: false,
            saving: false,
            dialogExhibition: false,
            validExhibitionForm: false,
            tmpCode: null,
            waiting: false,
            loading: true,
            isCurrentExhibitionAccepted: false,
            editingProfileId: false,
            sessionTimer: false,
            roomsLoaded: false,
            sessionActive: true,
            currentExhibition: null,
            timerStopwatch: null,
            editor: {

                // Called by FilePond to edit the image
                // - should open your image editor
                // - receives file object and image edit instructions
                open: (file, instructions) => {
                    // open editor here
                    console.log(file);
                },

                // Callback set by FilePond
                // - should be called by the editor when user confirms editing
                // - should receive output object, resulting edit information
                onconfirm: (output) => {},

                // Callback set by FilePond
                // - should be called by the editor when user cancels editing
                oncancel: () => {},

                // Callback set by FilePond
                // - should be called by the editor when user closes the editor
                onclose: () => {}
            },
            rules: {
                required: v => !!v || 'обязательное',
                min: v => v.length >= 6 || 'минимум 6 символов',
                email: v => /.+@.+\..+/.test(v) || 'E-mail введен неверно',
                passwordMatch: () => this.user.password === this.passwordConfirm || ('пароли не совпадают'),
            }
        }
    },

    computed: {
        ...mapGetters({
            getChatsList: 'chats/getChatsList',
            getExhibitionsList: 'exhibitions/getExhibitionsList',
            getIsUserLoggedIn: 'auth/getIsUserLoggedIn',
            getUserTasks: 'exhibitions/getUserTasks',
            getErrors: 'exhibitions/getErrors',
            getStats: 'dnet/getStats',
            getUserData: 'auth/getUserData',
            getUserProfile: 'auth/getUserProfile',
        }),



        serverOptions: function() {
            return {
                process: {
                    url: this.exhibition && this.exhibition.exhibition_id > 0 ? apiConfig.url + '/file/save/exhibition/' + this.exhibition.exhibition_id : apiConfig.url + '/file/save/exhibition/0/' + this.tmpCode,
                    headers: {
                        Authorization: `Bearer ${TokenService.getToken()}`
                    }
                },
                revert: async (file, load, error) => {
                    file = JSON.parse(file)
                    if (file && file.files && file.files[0]) {
                        await this.deleteFile(file.files[0].id)
                    }
                    load()
                },
                //fetch: null,
                //revert: null
            }
        },


        maxDays: function() {
            let days = 0
            if (this.getExhibitionsList && this.getExhibitionsList.length) {
                let acceptExhibitions = this.getExhibitionsList.filter(item => item.accepted)
                for (let i = 0; i < acceptExhibitions.length; i++) {
                    if (acceptExhibitions[i].duration > days) {
                        days = acceptExhibitions[i].duration
                    }
                }
            }
            return days
        },

        openExhibitions: function() {
          return this.getExhibitionsList.filter(item => true)
        },
        currentUserId: function() {
            return this.patientId ? this.patientId : (this.getUserData ? this.getUserData.id + '' : '')
        },
        initials() {
            if (this.getUserData) {
                let names = this.getUserData.name.split(' ')
                return names[0].substring(0, 1) + (names.length > 1 ? names[1].substring(0, 1) : '')
            } else {
                return '—'
            }
        },

    },

    /*destroyed() {
        socket.off("connect_error");
        socket.off("private message");
    },*/

    watch: {
        async filter() {
            this.waiting = true
            localStorage.setItem('filterExhibitions', this.filter)
            await this.fetchExhibitionsList({category: this.filter})
            await setTimeout(() => {
                this.waiting = false
            }, 200)
        }
    },

    beforeDestroy() {
        this.clearTimeout()
    },


    async created () {
        //this.timerStopwatch = new Timer();
        await this.fetchExhibitionsList({category: this.filter})
        this.loading = false
        //await this.startSession(true)

        /*this.timerStopwatch.addEventListener('secondsUpdated',  (e) => {
            this.sessionClock = this.timerStopwatch.getTimeValues().toString()
            // $('#basicUsage').html(timer.getTimeValues().toString());
        });*/

        /*socket.auth = { username: this.getUserData.id };
        socket.connect();

        socket.on("private message", ({ content, from }) => {
            console.log('content on PM', content)
            this.$refs.chat.addMessageToChat(content.chat_id, content)
        });*/

        /*await this.fetchStats({
            own: true,
            period: 'all',
            begin: null,
            end: null,
        })*/
    },

    methods: {
        ...mapActions({
            fetchChatsList: 'chats/fetchChatsList',
            fetchExhibitionsList: 'exhibitions/fetchExhibitionsList',
            deleteChat: 'chats/deleteChat',
            clearErrors: 'exhibitions/clearErrors',
            saveExhibition: 'exhibitions/saveExhibition',
            nextDay: 'exhibitions/nextDay',
            deleteFile: 'user/deleteFile',
            deleteExhibition: 'exhibitions/deleteExhibition',
            acceptExhibition: 'exhibitions/acceptExhibition',
            checkSession: 'dnet/checkSession',
            finishSession: 'dnet/finishSession',
            fetchStats: 'dnet/fetchStats',
            closeChat: 'chats/closeChat',
            refuseChat: 'chats/refuseChat',
        }),

        editExhibition: function(exhibition) {
            this.tmpCode = 'xxxxxxxxxx'.replace(/[x]/g, function(c) {
                return (Math.random() * 16 | 0).toString(16)
            })
            this.dialogExhibition = true
            this.exhibition = exhibition
        },

        onRemoveFile: async function(errRes, file) {
            console.log('onRemoveFile', file)

        },

        deleteExhibitionConfirm: async function(exhibitionId) {
            const res = await this.$confirm('Удалить выставку?', { title: 'Внимание', icon: '', color: '#f8495a', buttonTrueText: 'Да', buttonFalseText: 'Нет' })
            if (res) {
                this.saving = true

                try {
                    await this.clearErrors()
                    this.exhibition.tmp_code = this.tmpCode
                    this.exhibition.action = 'delete_exhibition'
                    await this.deleteExhibition(exhibitionId)
                    if (this.getErrors.length > 0) {
                        this.$root.$emit('error:show', this.getErrors[0])
                    } else {
                        await this.fetchExhibitionsList({})
                        this.dialogExhibition = false
                    }
                    this.saving = false
                } catch(e) {
                    console.error(e)
                    this.saving = false
                }
            }
        },

        saveExhibitionConfirm: async function() {
            const res = await this.$confirm('Сохранить выставку?', { title: 'Внимание', icon: '', color: '#f8495a', buttonTrueText: 'Да', buttonFalseText: 'Нет' })
            if (res) {
                this.saving = true
                try {
                    this.exhibition.tmp_code = this.tmpCode
                    this.exhibition.action = this.exhibition.exhibition_id > 0 ? 'update_exhibition' : 'create_exhibition'
                    await this.saveExhibition(this.exhibition)
                    if (this.getErrors.length > 0) {
                        this.$root.$emit('error:show', this.getErrors[0])
                    } else {
                        await this.fetchExhibitionsList({category: this.filter})
                        this.dialogExhibition = false
                    }
                    this.saving = false
                } catch(e) {
                    console.error(e)
                    this.saving = false
                }


            }
        },

        createExhibition: function() {
            this.tmpCode = 'xxxxxxxxxx'.replace(/[x]/g, function(c) {
                return (Math.random() * 16 | 0).toString(16)
            })
            this.dialogExhibition = true
            this.exhibition = {}
        },

        handleFilePondInit: function () {
            console.log("FilePond has initialized");

            // FilePond instance methods are available on `this.$refs.pond`
        },
        makeExhibition: function () {
            console.log("makeExhibition");


        },

        async messageBroadcast(content) {
            console.log('messageBroadcast', content)
            socket.emit("private message", {
                content,
                to: content.recipientId,
            });
        },

        async nextDayAndUpdate() {
            await this.nextDay()
            this.$router.go()
        },

        async onAnswered() {
            let room = this.rooms.find(r => r.id == this.currentChatId)
            if (room && room.status == 'preparing' || room.status == 'closed') {
                await this.loadRooms()
            }
        },

        async onExhibitionSelected(exhibition) {
            //console.log('datadata', data)
            this.currentExhibition = exhibition;
            this.dialogViewExhibition = true
            //this.currentExhibition = data;
            //this.isCurrentExhibitionAccepted = data.accepted
        },

        async startSession(check) {
            let session = await this.checkSession(check)
            if (session.found) {
                this.sessionActive = session
                this.clearTimeout()
                this.timerStopwatch.start({
                    startValues: {
                        seconds: session.duration
                    }
                })
                this.sessionTimeout = setTimeout(() => {
                    this.startSession(true)
                }, session.left * 1000 + 1000)
            } else {
                this.clearTimeout()
                this.sessionActive = false
                this.sessionClock = ''
                this.timerStopwatch.reset()
                this.timerStopwatch.stop()
            }
        },

        async finishSessionConfirm() {
            await this.finishSession()
            this.clearTimeout()
            this.sessionActive = false
            this.sessionClock = ''
            this.timerStopwatch.reset()
            this.timerStopwatch.stop()
            await this.fetchStats({
                own: true,
                period: 'all',
                begin: null,
                end: null,
            })
        },

        clearTimeout() {
            if (this.sessionTimer) {
                clearTimeout(this.sessionTimer)
                this.sessionTimer = null
            }
        },

        async loadRooms() {
            await this.fetchChatsList({code: this.$route.params.code})
            const rooms = []
            for (let i = 0; i < this.getChatsList.length; i++) {
                rooms.push(this.getChatsList[i])
            }
            this.rooms = rooms
            this.roomsLoaded = true
        },

        deleteChatConfirm: async function(chatId) {
            const res = await this.$confirm('Delete this exhibition?', { title: 'Warning', icon: '', color: '#f8495a', buttonTrueText: 'Yes', buttonFalseText: 'No' })
            if (res) {
                await this.deleteChat(chatId)
                await this.loadRooms()

            }
        },

        closeChatConfirm: async function(chatId) {
            const res = await this.$confirm('Close this exhibition?', { title: 'Warning', icon: '', color: '#f8495a', buttonTrueText: 'Yes', buttonFalseText: 'No' })
            if (res) {
                await this.closeChat({chat_id: chatId})
                await this.loadRooms()

            }
        },

        acceptExhibitionConfirm: async function(exhibitionId) {
            const res = await this.$confirm('Accept this exhibition?', { title: 'Warning', icon: '', color: '#f8495a', buttonTrueText: 'Yes', buttonFalseText: 'No' })
            if (res) {
                await this.clearErrors()
                await this.acceptExhibition({exhibition_id: exhibitionId})
                if (this.getErrors.length > 0) {
                    this.$root.$emit('error:show', this.getErrors[0])
                } else {
                    await this.fetchExhibitionsList({category: this.filter})
                }

            }
        },

        refuseChatConfirm: async function(chatId) {
            const res = await this.$confirm('Refuse this exhibition?', { title: 'Warning', icon: '', color: '#f8495a', buttonTrueText: 'Yes', buttonFalseText: 'No' })
            if (res) {
                await this.refuseChat(chatId)

                if (this.getErrors.length > 0) {
                    this.$root.$emit('error:show', this.getErrors[0])
                } else {
                    await this.loadRooms()
                }





            }
        },

    }
}
